import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-578ce165"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Remarks_Content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Remarks_Header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "Remarks_Header_Title" }, "備考入力 変更履歴")
], -1))
const _hoisted_3 = { class: "Remarks_Main" }
const _hoisted_4 = { class: "Remarks_Table" }
const _hoisted_5 = { class: "Remarks_Table_Yoko" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "入力ユーザー", -1))
const _hoisted_7 = { class: "Remarks_Table_Yoko" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "書誌CD", -1))
const _hoisted_9 = { class: "Remarks_Table_Yoko" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "JANCD", -1))
const _hoisted_11 = { class: "Remarks_Table_Yoko" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "ISBN", -1))
const _hoisted_13 = { class: "Remarks_Table_Yoko" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "書誌名", -1))
const _hoisted_15 = { class: "Remarks_Table_Yoko" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "Remarks_Table_InputBikou" }, [
  /*#__PURE__*/_createTextVNode(" 備考"),
  /*#__PURE__*/_createElementVNode("br", { class: "Remarks_Index" }),
  /*#__PURE__*/_createTextVNode("内容 ")
], -1))
const _hoisted_17 = { class: "Remarks_Table_InputBikou" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "Remarks_Table_Yoko" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createTextVNode("表示"),
  /*#__PURE__*/_createElementVNode("br", { class: "Remarks_Index" }),
  /*#__PURE__*/_createTextVNode("期限")
], -1))
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "Remarks_Table_MukigenCheck" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "mukigenCheck" }, "無期限", -1))
const _hoisted_24 = ["checked"]
const _hoisted_25 = { class: "Remarks_Table_Yoko" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "入力日時", -1))

import axios from "axios";
import { ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { Notyf } from "notyf";


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemRemarksLog',
  emits: ["showGlobalHeader", "toggleGlobalHeader"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
emit("toggleGlobalHeader");
const route = useRoute();
const store = useStore();
const notyf = new Notyf();

// データ取得--------------------------------------------------
const display_data = ref({
  username: "",
  janCd: "",
  isbn: "",
  syosiCd: "",
  title: "",
  itemRemarks: "",
  remarksDeadline: "",
  processingTime: "",
});
const getLogData = async () => {
  try {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/syosi/log-remarks?uuid=${route.query.uuid}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    display_data.value = res.data;
  } catch (error) {
    notyf.error("データを取得できませんでした");
    console.log(error);
  }
};
getLogData();
// 日付形式-------------------------------------------------------------
const convertDate = (registerDate: string) => {
  const targetDate = new Date(registerDate);
  const year = targetDate.getFullYear();
  const month = targetDate.getMonth() + 1;
  const day = targetDate.getDate();
  const hour = targetDate.getHours();
  const minutes = targetDate.getMinutes();
  const seconds = targetDate.getSeconds();
  return `${year}/${month}/${day} ${String(hour).padStart(2, "0")}:${String(
    minutes
  ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _createElementVNode("tr", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("td", null, _toDisplayString(display_data.value.username), 1)
        ]),
        _createElementVNode("tr", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("td", null, _toDisplayString(display_data.value.syosiCd), 1)
        ]),
        _createElementVNode("tr", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("td", null, _toDisplayString(display_data.value.janCd), 1)
        ]),
        _createElementVNode("tr", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("td", null, _toDisplayString(display_data.value.isbn), 1)
        ]),
        _createElementVNode("tr", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("td", null, _toDisplayString(display_data.value.title), 1)
        ]),
        _createElementVNode("tr", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("td", _hoisted_17, [
            _createElementVNode("input", {
              type: "text",
              class: "Remarks_Table_InputText",
              value: display_data.value.itemRemarks,
              disabled: ""
            }, null, 8, _hoisted_18)
          ])
        ]),
        _createElementVNode("tr", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("td", null, [
            _createElementVNode("input", {
              type: "date",
              class: "Remarks_Table_InputDate",
              value: 
                display_data.value.remarksDeadline === '9999-12-31'
                  ? null
                  : display_data.value.remarksDeadline
              ,
              disabled: ""
            }, null, 8, _hoisted_21),
            _createElementVNode("span", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("input", {
                type: "checkbox",
                id: "mukigenCheck",
                checked: display_data.value.remarksDeadline === '9999-12-31',
                disabled: ""
              }, null, 8, _hoisted_24)
            ])
          ])
        ]),
        _createElementVNode("tr", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("td", null, _toDisplayString(convertDate(display_data.value.processingTime)), 1)
        ])
      ])
    ])
  ]))
}
}

})